/* eslint-disable no-unused-vars */
import React, { useCallback, useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import '../styles/table-grid.css';
import TableTextInput from './table-text-input';

const $ = window.$;
const delayChange = 650;
let timerCellChange = null;

export function TableCell(props) {
  const { app, data, em, debug } = props;
  const { handlers } = app || {};

  const cellProps = {
    align: em.align,
    colSpan: props.colSpan,
    rowSpan: props.rowSpan,
    className: em.class || props.className,
  }

  let inputClass = em.align ? `text-${em.align}` : '';
  switch (em.type) {
    case 'DateCell':
      inputClass = 'text-center';
      break;

    case 'NumberCell':
      inputClass = 'text-right';
      break;

    default:
      break;
  }
  if (em.style && em.style.fontSize && em.style.fontSize==='small') {
    inputClass += ` form-control-sm`;
  } else if (em?.size) {
    inputClass += ` form-control-${em.size}`;
  }

  if (em.inputClass) {
    inputClass += ` ${em.inputClass}`;
  } else if (em.class) {
    inputClass += ` ${em.class}`;
  }

  const cellStyle = props.em.cellStyle || {};
  if (em.onCellClick) {
    cellStyle.cursor = 'pointer';
  }

  const [objLang, setObjLang] = useState(props.lang || 'th');
  const [selectedDate, setSelectedDate] = useState(null);
  const [initialized, setInitialized] = useState(false);
  const [requestUpdate, setRequestUpdate] = useState(false);

  const [value, setValue] = useState((props.data && em.field && props.data[em.field]) || '');
  const handleDefaultChange = useCallback((e) => {}, []);

  const handleCellClick = useCallback(
    (e) => {
      e.preventDefault();

      if (debug) {
        console.info(em.onCellClick);
      }

      if (!em.onCellClick) return;
      if (!handlers) {
        if (!app.disableTableGridError) {
          console.error("'handlers' is not found. 'app' property with 'handlers' must be assigned");
          console.info('<TableGrid em={...} data={...} app={...} />');
        }
        return;
      }
      if (em.onCellClick && handlers[em.onCellClick]) handlers[em.onCellClick](data);
    },
    [app.disableTableGridError, data, em.onCellClick, handlers]
  );

  const dateFmtOptions = { day: 'numeric', month: 'short', year: 'numeric' };
  const dateFmt = new Intl.DateTimeFormat(props.locale || 'en-UK', dateFmtOptions);

  const numberFmt = Intl.NumberFormat('en-US', {
    style: 'decimal',
    minimumFractionDigits: em.digits !== undefined ? em.digits : props.digits !== undefined ? props.digits : 2,
    maximumFractionDigits: em.digits !== undefined ? em.digits : props.digits !== undefined ? props.digits : 2,
  });

  const integerFmt = Intl.NumberFormat('en-US', {
    style: 'decimal',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });

  const fractionFmt2 = Intl.NumberFormat('en-US', {
    style: 'decimal',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  const fractionFmt3 = Intl.NumberFormat('en-US', {
    style: 'decimal',
    minimumFractionDigits: 3,
    maximumFractionDigits: 3,
  });

  const refInput = useRef(null);

  useEffect(() => {
    if (em.type !== 'NumberCell') return;
    const _value = props.data && em.field && props.data[em.field];
    setValue(_value);
  }, [em.field, em.type, props.data]);

  useEffect(() => {
    if (em.type !== 'NumberCell') return;
    // console.info(refInput.current.readOnly);
    if (refInput.current === document.activeElement
      && !refInput.current.readOnly) return;
    
    let _fmtd = '';
    let _value = value;
    if (_value && _value !== '') {
      _value = `${_value}`.replaceAll(',', '');
      _fmtd = numberFmt.format(_value);
    }

    refInput.current.value = _fmtd;
  }, [em.type, numberFmt, value]);

  useEffect(() => {
    if (objLang !== (props.lang || 'th')) {
      setObjLang(props.lang || 'th');
      setInitialized(false);
    }
  }, [objLang, props.lang]);

  useEffect(() => {
    if (em.type !== 'DateCell') return;
    if (initialized) return;

    $(refInput.current).datepicker('destroy');

    $(refInput.current)
      .datepicker({
        language: objLang, // props.lang || 'th',
        format: 'd M yyyy',
      })
      .on('changeDate', (e) => {
        // console.info('changeDate', e);
        const _date = e.date;
        // _date.setHours(0, 0, 0, 0);

        setSelectedDate(_date);
        // setRequestUpdate(true);

        if (em.field && props.onChange) {
          props.onChange({
            target: {
              name: em.field,
              value: _date instanceof Date ? _date.toLocaleString("sv-TH") : _date,
            },
          });
        }
    
      });

    setInitialized(true);
  }, [em.field, em.type, initialized, objLang, props]);

  /* 19-Jul-2022 : Fixed bug of infinity loop
  useEffect(() => {
    if (em.type !== 'DateCell') return;
    if (!requestUpdate) return;
    if (em.field && props.onChange) {
      props.onChange({
        target: {
          name: em.field,
          value: selectedDate && selectedDate !== '' ? selectedDate.toISOString() : '',
        },
      });
    }

    setRequestUpdate(false);
  }, [em.field, em.type, props, requestUpdate, selectedDate]);
  */

  useEffect(() => {
    if (em.type !== 'DateCell') return;
    let _date = (props.data && em.field && props.data[em.field]) || '';
    if (_date !== '' && typeof _date !== 'object') _date = new Date(_date);

    // if (typeof _date === 'object') _date.setHours(0,0,0,0);

    $(refInput.current).datepicker('update', _date);
    setSelectedDate(_date);
  }, [em.field, em.type, props.data]);

  const handleKeyUp = useCallback(
    (e) => {
      if (e.key.match(/^tab$/i)) return;

      props.onChange({
        target: { name : null },
      });
    },
    [props],
  )
  
  const handleBlur = useCallback(
    (e) => {
      if (em.type !== 'NumberCell') return;
      if (timerCellChange) clearTimeout(timerCellChange);

      const _hasChanged = +value !== parseFloat(`${e.target.value.replace(/,/g, '')}`);
      // if (_hasChanged) console.info(value, e.target.value);
      let _fmtd = '';
      let _value = e.target.value;
      if (_value !== '') {
        _value = `${_value}`.replaceAll(',', '');
        setValue(parseFloat(_value));
        _fmtd = numberFmt.format(_value);
      } else {
        setValue('');
      }

      if (_hasChanged && props.onChange) {
        props.onChange({
          target: {
            name: e.target.name,
            value: _value,
          },
        });
      }

      refInput.current.value = _fmtd;
      /*
      if (!_hasChanged) return;

      if (props.onChange) {
        props.onChange({
          target: {
            name: e.target.name,
            value: _value,
          },
        });
      }
      */
    },
    [em.type, numberFmt, props, value]
  );

  const handleNumberCellChange = useCallback((e) => {
    e.preventDefault();
    if (timerCellChange) clearTimeout(timerCellChange);

    if (debug) {
      console.info(props.onChange);
      console.info(e.target.name, e.target.value);
    }

    const _hasChanged = +value !== parseFloat(`${e.target.value.replace(/,/g, '')}`);
    // if (_hasChanged) console.info(value, e.target.value);
    if (!_hasChanged) return;
    if (!props.onChange) return;

    // DO NOT USE DELAY CHANGE, it affect updating
    timerCellChange = setTimeout(() => {
      props.onChange(e);
    }, delayChange);
    //
  }, [app.disableTableGridError, data, props.onChange, handlers, value])

  switch (em.type) {
    case 'ActionButtons':
      return (
        <td className={(em.class || '') + ' action-menu'} style={cellStyle}>
          {em.buttons &&
            em.buttons.map((t, i) => {
              let _show = true;
              if (typeof t.showBy !== 'undefined') {
                const criteria = t.showBy.split(':');
                const _fld = criteria[0];

                if (data[_fld]) {
                  if (criteria.length > 1) {
                    _show = data[_fld].match(new RegExp(criteria[1], 'i')) ? true : false;
                  } else {
                    _show = (data[_fld]===true || data[_fld].match(/1|A|Y/i)) ? true : false;
                  }
                }

              }

              if (!_show) return null;

              return (
                <button
                  type="button"
                  className={"btn " + (t.outline ? `btn-outline-${t.color} mr-1` : '') }
                  key={i}
                  style={{ cursor: 'pointer' }}
                  onClick={(e) => {
                    e.preventDefault();
                    app && app.handlers && t.click && app.handlers[t.click] && app.handlers[t.click](data);
                  }}
                >
                  {t.icon && t.icon !== '' && (
                    <i className={t.icon + (t.color ? ` text-${t.color}` : '')}></i>
                  )}
                  {t.icon && t.icon !== '' && t.text && t.text !== '' && <br />}
                  {t.text && t.text !== '' && (
                    <small className={(t.color ? ` text-${t.color}` : '')}>{t.text}</small>
                  )}
                </button>
              );
            })}
        </td>
      );

    case 'ActionMenu':
      return (
        <td className={(em.class || '') + ' action-menu'} style={{ width: '1rem' }} {...cellProps}>
          <div className="dropdown">
            <button
              className="btn btn-sm btn-light"
              type="button"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <i className="fas fa-ellipsis-v"></i>
            </button>
            <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
              {em.buttons &&
                em.buttons.map((t, i) => {
                  if (t.type && t.type === 'hr') {
                    return <hr key={i} />;
                  }

                  return (
                    <a
                      key={i}
                      className="dropdown-item"
                      style={{ cursor: 'pointer' }}
                      onClick={(e) => {
                        e.preventDefault();
                        app && app.handlers && t.click && app.handlers[t.click] && app.handlers[t.click](data);
                      }}
                    >
                      {t.label}
                    </a>
                  );
                })}
            </div>
          </div>
        </td>
      );

    case 'CheckCell':
      return (
        <td className={'p-2 ' + em.class} style={cellStyle} {...cellProps}>
          <input
            type="checkbox"
            className="form-control"
            name={em.field}
            checked={data && em && em.field && ((data[em.field] === 'Y') || (+data[em.field] > 0))}
            onChange={(e) => {
              e.preventDefault();
              // console.info(e.target.checked);
              const _requestChecked = e.target.checked;

              // This part to ensure refresing checkbox
              e.target.style.visibility = 'hidden';
              setTimeout(() => {
                e.target.checked = _requestChecked;
                e.target.style.visibility = 'visible';
              }, 125);
              // End refresing

              app && app.handlers && em.click && app.handlers[em.click] && app.handlers[em.click]({target: e.target, data});

            }}
          />
        </td>
      );

    case 'TextCell':
      if (Array.isArray(em.field)) {
        return (
          <td className={em.class} style={cellStyle} {...cellProps}>
            {data &&
              em.field &&
              em.field.map((t, i) => {
                return (
                  <TableTextInput key={i} 
                    data={data}
                    em={{...em, name: t}}
                    inputclassName={inputClass}
                    datalist={props.datalist}
                    onChange={props.onChange} 
                    onBlur={props.onBlur}
                  />
                )
              })
            }
          </td>
        )
      }

      return (
        <td className={em.class} style={cellStyle} {...cellProps}>
          <TableTextInput 
            data={data}
            em={em}  
            inputclassName={inputClass}
            datalist={props.datalist}
            onChange={props.onChange} 
            onBlur={props.onBlur}
          />
        </td>
      )
      /* Moved to table-text-cell.js since 26-May-2022
      return (
        <td className={em.class} style={cellStyle} {...cellProps}>
          <input
            className={`form-control ${inputClass}`}
            name={em.field}
            value={data && em.field && (data[em.field] || '')}
            onChange={props.onChange}
            list={em.datalist || props.datalist}
            autoComplete="off"
            readOnly={em.readOnly}
          />
        </td>
      );*/

    case 'DateCell':
      return (
        <td className={em.class} style={cellStyle} {...cellProps}>
          <input
            ref={refInput}
            className={`form-control ${inputClass}`}
            name={em.field}
            // value={data && em.field && (data[em.field] || '')}
            // onChange={props.onChange}
            autoComplete="off"
          />
        </td>
      );

    case 'NumberCell':
      return (
        <td className={em.class} style={cellStyle} {...cellProps}>
          <input
            ref={refInput}
            type="text"
            className={`form-control ${inputClass}`}
            name={em.field}
            // value={data && em.field && (data[em.field] || '')}
            onChange={handleNumberCellChange} // DO NOT USE onChange
            onBlur={handleBlur}
            onKeyUp={handleKeyUp}
            readOnly={em.readOnly}
            autoComplete="off"
          />
        </td>
      );

    case 'StaticSelectCell':
      return (
        <td className={em.class} style={cellStyle} {...cellProps}>
          <select
            className={`form-control ${inputClass}`}
            name={em.field}
            value={data && em.field && (data[em.field] || '')}
            onChange={props.onChange}
          >
            <option value="">---</option>
            {em.options &&
              em.options.map((t, i) => {
                return (
                  <option key={i} value={t.value}>
                    {t.text}
                  </option>
                );
              })}
          </select>
        </td>
      );

    case 'ValidSelectCell':
      return (
        <td className={em.class} style={cellStyle} {...cellProps}>
          <select
            className={`form-control ${inputClass}`}
            name={em.field}
            title={em.field}
            value={data && em.field && (data[em.field] || '')}
            onChange={props.onChange}
          >
            <option value="">---</option>
            {em.options &&
              app[em.options] &&
              app[em.options].map((t, i) => {
                return (
                  <option key={i} value={t.type_code}>
                    {t.type_desc}
                  </option>
                );
              })}
          </select>
        </td>
      );

    case 'DateViewCell': {
      // console.info(data[em.field]);
      const _d =
        data && em.field && data[em.field] && data[em.field] !== ''
          ? dateFmt.format(new Date(data[em.field]))
          : em.emptyText || '';
      return (
        <td className={em.class} style={cellStyle} onClick={handleCellClick} {...cellProps}>
          {data && em.field && (_d || em.emptyText || '')}
        </td>
      );
    }

    case 'NumberViewCell': {
      const _d =
        data && em.field && data[em.field] && data[em.field] !== '' ? numberFmt.format(+`${data[em.field]}`) : '';
      return (
        <td className={em.class} style={cellStyle} onClick={handleCellClick} {...cellProps}>
          {data && em.field && (_d || '')}
        </td>
      );
    }

    case 'ViewCell':
    default:
      if (Array.isArray(em.field)) {
        return (
          <td className={em.class} style={cellStyle} onClick={handleCellClick} {...cellProps}>
            {data &&
              em.field &&
              em.field.map((t, i) => {
                if (t === '\n') {
                  return (
                    <React.Fragment key={i}>
                      <br />
                    </React.Fragment>
                  );
                }

                if (t.match(/\|/)) {
                  const flds = t.split('|');
                  return (
                    <React.Fragment key={i}>
                      {flds.map((f, z) => {
                        if (f.substring(0, 1) === '$') {
                          return f.substring(1);
                        }

                        return (data[f] || '') + ' ';
                      })}
                      <br />
                    </React.Fragment>
                  );
                }

                if (t.substring(0, 1) === '$') {
                  return t.substring(1);
                }

                // const fx = t.match(/@(.+):(.+)(:(.+))*/);
                if (t.substring(0, 1) === '@') {
                  const s = t.substring(1).split(':');
                  const fx = [t, ...s];
                  if (fx) {
                    if (typeof props.app[fx[1]] !== 'function') {
                      if (!props.app.disableTableGridError) {
                        console.error(`${fx[1]} from ${t} is not function`, props.app);
                      }
                      return null;
                    }

                    let _data = data[fx[2]];
                    if (fx[3] && data[fx[3]]) {
                      _data = {};
                      _data[fx[2]] = data[fx[2]];
                      _data[fx[3]] = data[fx[3]];
                    }

                    // support static append text
                    if (fx[3] && !data[fx[3]]) {
                      _data = {};
                      _data[fx[2]] = data[fx[2]];
                      _data.append = fx[3];
                    }

                    return (
                      <React.Fragment key={i}>
                        {props.app[fx[1]](fx[2] === '?' ? data : _data || '')}
                        {/* <br /> */}
                      </React.Fragment>
                    );
                  }
                }

                const rxNumFmt = t.match(/(.+)#(.+)/);
                if (rxNumFmt) {
                  let _formatedValue = '';
                  let _fmt = integerFmt;
                  // if (rxNumFmt[2] === '2') _fmt = fractionFmt2;
                  switch(rxNumFmt[2]) {
                    case '3':
                      _fmt = fractionFmt3;
                      break;

                    case '2':
                      _fmt = fractionFmt2;
                      break;

                    default:
                  }

                  try {
                    if (rxNumFmt[2] === 'd') {
                      _formatedValue =
                        data && data[rxNumFmt[1]] && data[rxNumFmt[1]] !== ''
                          ? dateFmt.format(new Date(data[rxNumFmt[1]]))
                          : '';
                    } else {
                      _formatedValue =
                        data && data[rxNumFmt[1]] && !isNaN(data[rxNumFmt[1]]) ? _fmt.format(data[rxNumFmt[1]]) : ''; // '##.##'
                    }
                  } catch(ex) {
                    console.info(`Invalid Date: ${data[rxNumFmt[1]]}`);
                    return <React.Fragment key={i}>
                      {data[rxNumFmt[1]]}
                      &nbsp;
                    </React.Fragment>
                  }

                  return (
                    <React.Fragment key={i}>
                      {_formatedValue}
                      &nbsp;
                    </React.Fragment>
                  );
                }

                return (
                  <React.Fragment key={i}>
                    {data[t] || ''}
                    &nbsp;
                    <br />
                  </React.Fragment>
                );
              })}
          </td>
        );
      }

      return (
        <td className={em.class} style={cellStyle} onClick={handleCellClick} {...cellProps}>
          {data && em.field && (data[em.field] || '')}
        </td>
      );
  }
}

TableCell.defaultProps = {
  em: { type: 'TextCell' },
  app: { lang: 'en', locale: 'en-UK' },
  debug: false,
};

TableCell.propTypes = {
  app: PropTypes.any,
  em: PropTypes.any,
  debug: PropTypes.bool,
  data: PropTypes.any, 
  datalist: PropTypes.any,
  digits: PropTypes.number,
  lang: PropTypes.string,
  locale: PropTypes.any,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,

  colSpan: PropTypes.any,
  rowSpan: PropTypes.any,
  className: PropTypes.string,
}

export function TableGrid(props) {
  const { app, em, data } = props;
  const { columns, addable, removable, buttons } = em;
  const { handlers } = app || {};

  const hasActionMenu = em.columns ? em.columns.reduce((v,c) => c|=(c.type === 'ActionMenu'), false) : false;

  const maxRowsPerPage = (+em.rowsPerPage || 10);
  const [pages, setPages] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageIndex, setPageIndex] = useState(1);
  const [pageRecalc, setPageRecalc] = useState(true);
  const showPaginate = (+em.rowsPerPage > 0) && (pages.length > 1);

  useEffect(() => {
    setPageIndex(currentPage-1);
  }, [currentPage])

  useEffect(() => {
    // console.info(data[em.values], maxRowsPerPage, pages.length);
    if (!em.rowsPerPage) return;
    if (!pageRecalc) return;

    if (data && data[em.values] && data[em.values].length > 0) {
      const _totalPage = Math.ceil(data[em.values].length / maxRowsPerPage);
      // if (_totalPage !== pages.length) {
        const _pages = [];
        for (let p=1; p<=_totalPage; p++) _pages.push(p);
        setPages(_pages);
        if (currentPage > _totalPage) setCurrentPage(_totalPage);
        if (currentPage < 1 && _totalPage > 0) setCurrentPage(1);
      // }
    } else {
      setPages([]);
      setCurrentPage(0);
    }

    setPageRecalc(false);
  }, [em, data, pageRecalc, currentPage, showPaginate])

  useEffect(() => {
    if (!em.rowsPerPage) return;

    if (data && data[em.values] && data[em.values].length > 0) {
      const _totalPage = Math.ceil(data[em.values].length / maxRowsPerPage);
      if (_totalPage !== pages.length) {
        setPageRecalc(true);
      }
    } else {
      setPageRecalc(false);
    }
  }, [em, data, pages])

  const handleRowClick = useCallback(
    (idx) => {
      if (!handlers) {
        if (!app.disableTableGridError) {
          console.error("'handlers' is not found. 'app' property with 'handlers' must be assigned");
          console.info('<TableGrid em={...} data={...} app={...} />');
        }
        return;
      }
      if (em.onRowClick && handlers[em.onRowClick]) handlers[em.onRowClick](idx);
    },
    [app.disableTableGridError, em.onRowClick, handlers]
  );

  const handleCellChange = useCallback(
    (e, idx) => {
      if (em.onChange && handlers[em.onChange]) handlers[em.onChange](e, idx);
    },
    [em.onChange, handlers]
  );

  const handleDefaultButtonClick = useCallback(
    (e) => {
      if (!handlers) {
        console.error("'handlers' is not found. 'app' property with 'handlers' must be assigned");
        console.info('<TableGrid em={...} app={...} />\nor pass though ZectionGroup');
      }
    },
    [handlers]
  );

  return (
    <div className={"table-responsive zeta-table " + (hasActionMenu ? 'zeta-table-with-action' : '') }>
      <table className="table table-sm " style={em.style}>
        {em.caption && em.caption!=='' 
          && <caption>{em.caption}</caption> }
        <thead>
          <tr>
            {columns &&
              columns.map((t, i) => {
                if (t.head && t.head.indexOf('\n') >= 0) {
                  return <RawHtmlColumnHead key={i} align={t.align} style={t.style}>
                    {t.head}
                  </RawHtmlColumnHead>
                }

                return (
                  <th
                    key={i}
                    // align={t.align}
                    className={(t.class || '') + (t.type === 'ActionMenu' ? ' action-menu' : '')}
                    style={{...t.style, textAlign: t.align}}
                  >
                    {t.head || ''}
                  </th>
                );
              })}
            {removable && <th className="actions"></th>}
          </tr>
        </thead>
        <tbody>
          {data &&
            data[em.values] &&
            data[em.values].map((t, rowIndex) => {
              if (showPaginate && maxRowsPerPage > 0 && Math.floor(rowIndex / maxRowsPerPage)!==pageIndex) return;

              const _data_row = { ...data[em.values][rowIndex] };
              _data_row['@row_no'] = rowIndex + 1;

              let _key = rowIndex;
              if (em.keys && Array.isArray(em.keys)) {
                _key = em.keys.reduce((prev, curr) => {
                  return `${prev}-${(_data_row[curr] || '')}`;
                }, rowIndex);
              }

              return (
                <tr key={_key}
                  className={em?.onRowClick ? 'pointer' : ''}
                  onClick={(e) => {
                    e.preventDefault();
                    handleRowClick(rowIndex);
                  }}
                >
                  {columns &&
                    columns.map((v, c) => {
                      return (
                        <TableCell
                          key={`cell-${_key}-${c}`}
                          em={{...v, style: em.style}}
                          app={app}
                          lang={app.lang}
                          locale={app.locale}
                          data={_data_row}
                          onChange={(e) => handleCellChange(e, rowIndex)}
                          debug={em.debug}
                        />
                      );
                    })}
                  {removable && (
                    <td style={{ width: '2em' }}>
                      <button
                        type="button"
                        className={'btn btn-sm ' + (em.style && em.style.fontSize && em.style.fontSize==='small' && ' m-0 p-0') }
                        onClick={(e) => {
                          // console.info(rowIndex);
                          e.preventDefault();
                          if (handlers[em.onRemove]) handlers[em.onRemove](rowIndex);
                        }}
                      >
                        <i className="fas fa-trash"></i>
                      </button>
                    </td>
                  )}
                </tr>
              );
            })}
        </tbody>
        <tfoot>
          <tr>
            <td colSpan={(columns && columns.length) || 1} className="text-left">
              {addable && (
                <button
                  type="button"
                  className="btn btn-sm btn-secondary btn-icon-split"
                  onClick={handlers && em.onAdd ? handlers[em.onAdd] : null}
                >
                  <span className="icon text-white">
                    <i className="fas fa-plus"></i>
                  </span>
                  <span className="text d-none d-sm-inline">{em.labelAdd || 'เพิ่มบรรทัด'}</span>
                </button>
              )}
              {buttons && buttons.map((t,i) => {
                return (<button
                  type="button"
                  key={i}
                  name={t.name}
                  onClick={t.click && app.handlers && app.handlers[t.click] ? app.handlers[t.click] : handleDefaultButtonClick}
                  className={'btn btn-sm mx-1 btn-' + (t.color || 'info') + (t.icon ? ' btn-icon-split' : '')}
                >
                  {t.icon && (
                    <React.Fragment>
                      <span className="icon text-white">
                        <i className={t.icon}></i>
                      </span>
                      <span className="text d-none d-sm-inline">{t.label}</span>
                    </React.Fragment>
                  )}
                  {t.icon ? null : t.label}
                </button>)
              })}
            </td>
            {removable && <td>&nbsp;</td>}
          </tr>
        </tfoot>
      </table>

      {showPaginate && <nav aria-label="Page navigation">
        <ul className="pagination">
          <li className="page-item">
            <a className="page-link" aria-label="Previous"
              onClick={() => setCurrentPage(currentPage <= 1 ? 1 : currentPage-1)}>
              <span aria-hidden="true">&laquo;</span>
            </a>
          </li>
          {pages.map((p,i) => {
            return <li key={`page-${i}`} 
              className={"page-item " + (p===currentPage ? ' active' : '') }>
                <a className="page-link" onClick={() => setCurrentPage(p)}>{p}</a></li>
          })}
          <li className="page-item">
            <a className="page-link" aria-label="Next" 
              onClick={() => setCurrentPage(currentPage >= pages.length ? pages.length : currentPage+1)}>
              <span aria-hidden="true">&raquo;</span>
            </a>
          </li>
        </ul>
      </nav>}
    </div>
  );
}

TableGrid.defaultProps = {
  em: { debug: false, labelAdd: 'เพิ่มบรรทัด' },
  app: { lang: 'en', locale: 'en-UK' },
};

TableGrid.propTypes = {
  app: PropTypes.any, 
  em: PropTypes.any,
  data: PropTypes.any, 
  datalist: PropTypes.any,
  digits: PropTypes.number,
  lang: PropTypes.string,
  locale: PropTypes.any,
  onChange: PropTypes.func
}

function RawHtmlColumnHead
({align, style, children}) {
  const text = children.replace(/\n/g, '<br />');
  return (<th dangerouslySetInnerHTML={{__html:text}} style={{...style, textAlign: align}} />)
}

RawHtmlColumnHead
.propTypes = {
  align: PropTypes.string,
  style: PropTypes.any,

  children: PropTypes.any,
}